/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ChromeDayRendererQueryVariables = {
    calendarIds: Array<string>;
    dates: Array<unknown>;
    weekStartDates: Array<unknown>;
    timeZone: string;
};
export type ChromeDayRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ChromeDay_viewer">;
    };
};
export type ChromeDayRendererQuery = {
    readonly response: ChromeDayRendererQueryResponse;
    readonly variables: ChromeDayRendererQueryVariables;
};



/*
query ChromeDayRendererQuery(
  $calendarIds: [String!]!
  $dates: [LocalDate!]!
  $weekStartDates: [LocalDate!]!
  $timeZone: String!
) {
  viewer {
    ...ChromeDay_viewer_2oUNCs
    id
  }
}

fragment ChromeDayPicker_org on Org {
  id
  primaryOrgEmail
  personForUserErrorable {
    __typename
    ... on Person {
      __typename
      id
      primaryEmail
      emails
      isYou
      userId
      isUser
      profile {
        givenName
        familyName
        externalImageUrl
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment ChromeDay_viewer_2oUNCs on Viewer {
  user {
    givenName
    emails
    id
    orgs(first: 1000000) {
      edges {
        node {
          id
          ...ChromeDayPicker_org
          ...FeedScheduler_org
          experiments
          primaryOrgEmail
          eventColoringSettingsErrorable {
            __typename
            ... on EventColoringSettings {
              eventCategoryColorings {
                active
                eventCategory
                googleColorKey
                isUserSet
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          userWorkingHours(resolveOverrides: false) {
            workingHours {
              id
              type
              timeZone
              daySettings {
                day
                setting {
                  minSlot
                  maxSlot
                  excludedSlots
                }
              }
              dayOverrides {
                date
                setting {
                  minSlot
                  maxSlot
                  excludedSlots
                }
              }
            }
            id
          }
          calendarTimeStatsList(calendarIds: $calendarIds, timeZone: $timeZone, dates: $dates) {
            __typename
            ... on CalendarTimeStatsList {
              list {
                calendarId
                scoresByDate {
                  secondaryKey
                  busyMinutes
                  focusMinutes
                  totalMinutes
                  crawledStatus
                }
              }
            }
          }
          eventParentBaseWrapperByWeeksObject(weekStartDates: $weekStartDates, calendarIds: $calendarIds, includeAllDay: true, timeZone: $timeZone) {
            __typename
            ... on EventParentBaseWrapperByWeekObjectList {
              list {
                eventParentBases {
                  id
                  timestamp
                }
                eventParentsByDay {
                  eventParents {
                    id
                    eventParentBaseId
                    eventParentBaseTimestamp
                    events {
                      title
                      locked
                      isClockwiseEvent
                      isAllDay
                      calendarIds
                      organizer {
                        urnValue
                        responseStatus
                      }
                      attendees {
                        urnValue
                        responseStatus
                      }
                      creator {
                        urnValue
                      }
                      annotatedEvent {
                        userTags {
                          tag
                          states {
                            subjectType
                            subjectValue
                            value
                          }
                        }
                        orgTags {
                          tag
                          state {
                            subjectType
                            subjectValue
                            value
                          }
                        }
                        id
                      }
                      eventKey {
                        externalEventId
                        id
                      }
                      location
                      startTime {
                        dateOrDateTime
                        millis
                      }
                      endTime {
                        dateOrDateTime
                        millis
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment FeedScheduler_org on Org {
  id
  domains
  primaryOrgEmail
  experiments
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      shadowCalendarId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dates"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "weekStartDates"
    } as any, v4 = {
        "kind": "Variable",
        "name": "calendarIds",
        "variableName": "calendarIds"
    } as any, v5 = {
        "kind": "Variable",
        "name": "dates",
        "variableName": "dates"
    } as any, v6 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v7 = {
        "kind": "Variable",
        "name": "weekStartDates",
        "variableName": "weekStartDates"
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryEmail",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v15 = {
        "kind": "InlineFragment",
        "selections": [
            (v10 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v16 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v18 = [
        (v17 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatus",
            "storageKey": null
        } as any
    ], v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v20 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v21 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ChromeDayRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "ChromeDay_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v3 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ChromeDayRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personForUserErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v10 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "userId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isUser",
                                                                            "storageKey": null
                                                                        },
                                                                        (v14 /*: any*/)
                                                                    ],
                                                                    "type": "Person",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "shadowCalendarSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "shadowCalendarId",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "ShadowCalendarSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "calendarIds",
                                                                    "value": []
                                                                }
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personsByCalendarIdsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Person",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v10 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v14 /*: any*/),
                                                                                (v13 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "PersonList",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "message",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": "personsByCalendarIdsErrorable(calendarIds:[])"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "eventColoringSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "EventCategoryColoring",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventCategoryColorings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "active",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "eventCategory",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "googleColorKey",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isUserSet",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventColoringSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "resolveOverrides",
                                                                    "value": false
                                                                }
                                                            ],
                                                            "concreteType": "UserWorkingHours",
                                                            "kind": "LinkedField",
                                                            "name": "userWorkingHours",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WorkingHours",
                                                                    "kind": "LinkedField",
                                                                    "name": "workingHours",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v10 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "type",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "timeZone",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DaySetting",
                                                                            "kind": "LinkedField",
                                                                            "name": "daySettings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "day",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v16 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DayOverride",
                                                                            "kind": "LinkedField",
                                                                            "name": "dayOverrides",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "date",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v16 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v10 /*: any*/)
                                                            ],
                                                            "storageKey": "userWorkingHours(resolveOverrides:false)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v4 /*: any*/),
                                                                (v5 /*: any*/),
                                                                (v6 /*: any*/)
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "calendarTimeStatsList",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "CalendarTimeStats",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "calendarId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CalendarFocusTimeScore",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "scoresByDate",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "secondaryKey",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "busyMinutes",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "focusMinutes",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "totalMinutes",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "crawledStatus",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "CalendarTimeStatsList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "includeAllDay",
                                                                    "value": true
                                                                },
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/)
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "eventParentBaseWrapperByWeeksObject",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "EventParentBaseWrapperByWeekObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EventParentBase",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "eventParentBases",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v10 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "timestamp",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EventParentsForDay",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "eventParentsByDay",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "EventParent",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "eventParents",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                (v10 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "eventParentBaseId",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "eventParentBaseTimestamp",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Event",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "events",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "locked",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isClockwiseEvent",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isAllDay",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "calendarIds",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Attendee",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "organizer",
                                                                                                            "plural": false,
                                                                                                            "selections": (v18 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Attendee",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "attendees",
                                                                                                            "plural": true,
                                                                                                            "selections": (v18 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Attendee",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "creator",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v17 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "AnnotatedEvent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "annotatedEvent",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "UserTag",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "userTags",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        (v19 /*: any*/),
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "TagState",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "states",
                                                                                                                            "plural": true,
                                                                                                                            "selections": (v20 /*: any*/),
                                                                                                                            "storageKey": null
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "OrgTag",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "orgTags",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        (v19 /*: any*/),
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "TagState",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "state",
                                                                                                                            "plural": false,
                                                                                                                            "selections": (v20 /*: any*/),
                                                                                                                            "storageKey": null
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v10 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "EventKey",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "eventKey",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "externalEventId",
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v10 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "location",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "EventTime",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "startTime",
                                                                                                            "plural": false,
                                                                                                            "selections": (v21 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "EventTime",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "endTime",
                                                                                                            "plural": false,
                                                                                                            "selections": (v21 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventParentBaseWrapperByWeekObjectList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        },
                        (v10 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "43c41ac5614aff620fe86fe991f2ac88",
            "id": null,
            "metadata": {},
            "name": "ChromeDayRendererQuery",
            "operationKind": "query",
            "text": "query ChromeDayRendererQuery(\n  $calendarIds: [String!]!\n  $dates: [LocalDate!]!\n  $weekStartDates: [LocalDate!]!\n  $timeZone: String!\n) {\n  viewer {\n    ...ChromeDay_viewer_2oUNCs\n    id\n  }\n}\n\nfragment ChromeDayPicker_org on Org {\n  id\n  primaryOrgEmail\n  personForUserErrorable {\n    __typename\n    ... on Person {\n      __typename\n      id\n      primaryEmail\n      emails\n      isYou\n      userId\n      isUser\n      profile {\n        givenName\n        familyName\n        externalImageUrl\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChromeDay_viewer_2oUNCs on Viewer {\n  user {\n    givenName\n    emails\n    id\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          ...ChromeDayPicker_org\n          ...FeedScheduler_org\n          experiments\n          primaryOrgEmail\n          eventColoringSettingsErrorable {\n            __typename\n            ... on EventColoringSettings {\n              eventCategoryColorings {\n                active\n                eventCategory\n                googleColorKey\n                isUserSet\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          userWorkingHours(resolveOverrides: false) {\n            workingHours {\n              id\n              type\n              timeZone\n              daySettings {\n                day\n                setting {\n                  minSlot\n                  maxSlot\n                  excludedSlots\n                }\n              }\n              dayOverrides {\n                date\n                setting {\n                  minSlot\n                  maxSlot\n                  excludedSlots\n                }\n              }\n            }\n            id\n          }\n          calendarTimeStatsList(calendarIds: $calendarIds, timeZone: $timeZone, dates: $dates) {\n            __typename\n            ... on CalendarTimeStatsList {\n              list {\n                calendarId\n                scoresByDate {\n                  secondaryKey\n                  busyMinutes\n                  focusMinutes\n                  totalMinutes\n                  crawledStatus\n                }\n              }\n            }\n          }\n          eventParentBaseWrapperByWeeksObject(weekStartDates: $weekStartDates, calendarIds: $calendarIds, includeAllDay: true, timeZone: $timeZone) {\n            __typename\n            ... on EventParentBaseWrapperByWeekObjectList {\n              list {\n                eventParentBases {\n                  id\n                  timestamp\n                }\n                eventParentsByDay {\n                  eventParents {\n                    id\n                    eventParentBaseId\n                    eventParentBaseTimestamp\n                    events {\n                      title\n                      locked\n                      isClockwiseEvent\n                      isAllDay\n                      calendarIds\n                      organizer {\n                        urnValue\n                        responseStatus\n                      }\n                      attendees {\n                        urnValue\n                        responseStatus\n                      }\n                      creator {\n                        urnValue\n                      }\n                      annotatedEvent {\n                        userTags {\n                          tag\n                          states {\n                            subjectType\n                            subjectValue\n                            value\n                          }\n                        }\n                        orgTags {\n                          tag\n                          state {\n                            subjectType\n                            subjectValue\n                            value\n                          }\n                        }\n                        id\n                      }\n                      eventKey {\n                        externalEventId\n                        id\n                      }\n                      location\n                      startTime {\n                        dateOrDateTime\n                        millis\n                      }\n                      endTime {\n                        dateOrDateTime\n                        millis\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment FeedScheduler_org on Org {\n  id\n  domains\n  primaryOrgEmail\n  experiments\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      shadowCalendarId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b4f15b6d26128c1b4cbfa5ee6f923ccb';
export default node;
